import React, { useEffect, useRef } from "react";

const ParticleBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    let width = window.innerWidth;
    let height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;

    let particlesArray = [];

    // Mouse position track karne ke liye
    let mouse = {
      x: null,
      y: null,
      radius: 150, // Itne area me space banega
    };

    const handleMouseMove = (event) => {
      mouse.x = event.x;
      mouse.y = event.y;
    };

    const handleMouseOut = () => {
      mouse.x = undefined;
      mouse.y = undefined;
    };

    // Particle Class
    class Particle {
      constructor(x, y, directionX, directionY, size) {
        this.x = x;
        this.y = y;
        this.directionX = directionX;
        this.directionY = directionY;
        this.size = size;
      }

      // Draw method
      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2, false);
        ctx.fillStyle = "#7aa8cf"; // Dot color
        ctx.fill();
      }

      // Update method - mouse repulse logic
      update() {
        // Screen ke boundaries se bounce hona
        if (this.x > width || this.x < 0) {
          this.directionX = -this.directionX;
        }
        if (this.y > height || this.y < 0) {
          this.directionY = -this.directionY;
        }

        // Mouse Repulse (Space banane wala logic)
        let dx = mouse.x - this.x;
        let dy = mouse.y - this.y;
        let distance = Math.sqrt(dx * dx + dy * dy);

        if (distance < mouse.radius + this.size) {
          if (mouse.x < this.x && this.x < width - this.size * 10) {
            this.x += 3; // Right push
          }
          if (mouse.x > this.x && this.x > this.size * 10) {
            this.x -= 3; // Left push
          }
          if (mouse.y < this.y && this.y < height - this.size * 10) {
            this.y += 3; // Down push
          }
          if (mouse.y > this.y && this.y > this.size * 10) {
            this.y -= 3; // Up push
          }
        }

        // Normal movement
        this.x += this.directionX;
        this.y += this.directionY;
        this.draw();
      }
    }

    // Init Array
    const init = () => {
      particlesArray = [];
      let numberOfParticles = Math.min(Math.floor((height * width) / 9000), 160); // Particle density with cap for performance
      for (let i = 0; i < numberOfParticles; i++) {
        let size = Math.random() * 2 + 1;
        let x = Math.random() * width;
        let y = Math.random() * height;
        let directionX = Math.random() * 2 - 1; // Speed and direction
        let directionY = Math.random() * 2 - 1;
        particlesArray.push(new Particle(x, y, directionX, directionY, size));
      }
    };

    // Lines draw karne ka logic (Connection)
    const connect = () => {
      for (let a = 0; a < particlesArray.length; a++) {
        for (let b = a; b < particlesArray.length; b++) {
          let distance =
            (particlesArray[a].x - particlesArray[b].x) * (particlesArray[a].x - particlesArray[b].x) +
            (particlesArray[a].y - particlesArray[b].y) * (particlesArray[a].y - particlesArray[b].y);

          // Agar dots paas hain, tabhi line draw hogi
          if (distance < (width / 7) * (height / 7)) {
            let opacityValue = 1 - distance / 10000;
            ctx.strokeStyle = "rgba(120, 165, 210, " + opacityValue + ")"; // Line color
            ctx.lineWidth = 1;
            ctx.beginPath();
            ctx.moveTo(particlesArray[a].x, particlesArray[a].y);
            ctx.lineTo(particlesArray[b].x, particlesArray[b].y);
            ctx.stroke();
          }
        }
      }
    };

    // Animation Loop
    let animationId;
    const animate = () => {
      animationId = requestAnimationFrame(animate);
      ctx.clearRect(0, 0, width, height); // Har frame clear karna

      for (let i = 0; i < particlesArray.length; i++) {
        particlesArray[i].update();
      }
      connect();
    };

    // Window resize handle karna
    const handleResize = () => {
      width = window.innerWidth;
      height = window.innerHeight;
      canvas.width = width;
      canvas.height = height;
      init();
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseout", handleMouseOut);
    window.addEventListener("resize", handleResize);

    init();
    animate();

    return () => {
      cancelAnimationFrame(animationId);
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseout", handleMouseOut);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return <canvas ref={canvasRef} className="particle-canvas" />;
};

export default ParticleBackground;